import { ChannelTypeInternal, SourceThresholdInternal } from '../../../../../../../data-access/gql-types/graphql';
import { useDevicesAndChannelsContext } from '../../../../../context/devices-and-channels';

export const useConfigurationValidation = (source: SourceThresholdInternal) => {
  const { channel } = useDevicesAndChannelsContext();
  const validationRules = channel?.data.type === ChannelTypeInternal.Meter ? channel.data.validationRules : [];

  const validation = validationRules.find((x) => x.key === source);

  const roundStepToOne = (step?: number) => Math.round((step || 1) * 10) / 10;

  return {
    validation,
    roundStepToOne,
  };
};
